import styles from './Callout.module.css';

import { ReactNode } from 'react'
type props = {
    children: ReactNode
}

export default function Callout({ children }: props) {
    return (
        <div id={styles.wrapper}>
            <div id={styles.content}>
                <p className={styles.text}>
                    {children}
                </p>
            </div>
        </div>
    );
}
